import { defa } from 'defa-object';
import ClusterModel    from 'scripts/poppet/cluster-model';

/**
 * defa.models.Warmup
 * The DEFA Warmup model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	warmup: '/warmUp/warmUp?attrs=',
};

const Warmup = ClusterModel.extend( {
	collectionName: 'warmups',
	
	url: function() {
		return api.linkcom + this.get('id') + api.warmup + this.getAttributes();
	},
	
	onError: function (model, response, options) {
		let models = this._getModels();
		for (let index in models ) {
			models[index].trigger('error', model, response, options);
		}
	},
	
	_getModels: function() {
		let id = this.get('id');
		return [
			channel.request('warmupStates').get(id),
			channel.request('warmupSettings').get(id),
			channel.request('pickupTimes').get(id)
		];
	},
	
});

export default Warmup;
